export var documentLoaded = new Promise(function (resolve) {
  if (/^loaded|^i|^c/i.test(document.readyState)) {
    resolve();
  } else {
    once(document, 'DOMContentLoaded', resolve);
  }
});
export var beforeDocumentUnload = new Promise(function (resolve) {
  window.addEventListener('beforeunload', function () {
    once(window, 'beforeunload', function (_ref) {
      var defaultPrevented = _ref.defaultPrevented;

      if (!defaultPrevented) {
        resolve();
      }
    });
  }, true);
});

function once(target, event, callback) {
  target.addEventListener(event, function handler(event) {
    target.removeEventListener(event, handler);
    callback(event);
  });
}